import { render } from "./PlanCardSingle.vue?vue&type=template&id=2242b99d&scoped=true"
import script from "./PlanCardSingle.vue?vue&type=script&lang=js"
export * from "./PlanCardSingle.vue?vue&type=script&lang=js"

import "./PlanCardSingle.vue?vue&type=style&index=0&id=2242b99d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2242b99d"]])

export default __exports__